import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";
import { ResponsivePicture } from "src/atoms/ResponsivePicture";
import { BREAKPOINTS } from "src/breakpoints";

const StyledProductCard = styled.div<{
  centerText?: boolean | undefined;
  isGated?: boolean | undefined;
  isLastTile?: boolean | undefined;
  showHoverBorder?: boolean | undefined;
}>`
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    div[data-wishlist-hover="false"] svg {
      transition: opacity 0.3s;
      opacity: 0;
    }
    &:hover > div[data-wishlist-hover="false"] svg {
      opacity: 1;
    }
  }

  .ProductView__productPhotos {
    border-radius: 4px;
    border: ${({ isGated, theme }) =>
      isGated ? `1px solid ${theme.colors.tone.white}` : ""};

    &:hover {
      border: ${({ showHoverBorder }) =>
        showHoverBorder ? `1px solid #eeeeee` : ""};
    }
  }

  ${({ isLastTile }) =>
    isLastTile &&
    `
    .ProductView__productPhotos video {
      filter: blur(6px);
    }

    @media (min-width: ${BREAKPOINTS.lg}) {
      .ProductView__productPhotos video {
        filter: none;
      }

      &:hover .ProductView__productPhotos video {
        filter: blur(6px);
      }
    }
  `}

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    :hover {
      .ProductView__loginButton {
        display: block;
      }
    }
  }
`;

const StyledCardBrand = styled.div<{
  isPlaceholder?: boolean;
}>`
  margin-top: ${({ theme }) => theme.space.space16};
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.tone.black};

  ${({ isPlaceholder }) =>
    isPlaceholder &&
    `
    height: 20px;
    width: 75px;
    max-width: 100%;
  `}
`;

const StyledCardProduct = styled.div<{
  isPlaceholder?: boolean;
}>`
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  line-height: 20px;
  text-transform: lowercase;
  color: ${({ theme }) => theme.colors.tone.black};
  overflow: hidden;
  text-overflow: ellipsis;

  &:first-letter {
    text-transform: capitalize;
  }

  ${({ isPlaceholder }) =>
    isPlaceholder &&
    `
    margin-top: 4px;
    height: 17px;
    width: 180px;
    max-width: 100%;
  `}
`;

const StyledCardPrices = styled.div<{
  isPlaceholder?: boolean;
}>`
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.tone.black};

  ${({ isPlaceholder }) =>
    isPlaceholder &&
    `
    margin-top: 4px;
    height: 21px;
    width: 150px;
    max-width: 100%;
  `}
`;

const StyledCardRegularPrice = styled.span`
  margin-left: ${({ theme }) => theme.space.space8};
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.tone.anthracite};
`;

const StyledCardSizes = styled.div<{
  isPlaceholder?: boolean;
}>`
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  white-space: normal;

  ${({ isPlaceholder }) =>
    isPlaceholder &&
    `
    margin-top: 4px;
    height: 17px;
    width: 110px;
    max-width: 100%;
  `}
`;

const Image = styled(ResponsivePicture)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  &.is-gated {
    pointer-events: none;
  }
`;

const LastTileVideo = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

const LoginButton = styled(Button)`
  position: absolute;
  text-wrap: nowrap;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: none;
  }
`;

export {
  StyledProductCard,
  StyledCardBrand,
  StyledCardProduct,
  StyledCardPrices,
  StyledCardRegularPrice,
  StyledCardSizes,
  Image,
  LastTileVideo,
  LoginButton,
};
